import { LUMORA_PROD_MEDIA_BASE_URL } from "@lumora/bridge";

/**
 * Legacy disk photos lived on the Render Express app.
 * After DNS cutover, https://alamirauto.com/data/* is the Pages SPA (HTML), not JPEGs.
 * Keep pointing unmigrated keys at the Render origin until alamirmedia rewrites to tenants/*.
 */
const LEGACY_MEDIA =
  (import.meta.env.VITE_LUMORA_LEGACY_MEDIA as string | undefined)?.replace(/\/+$/, "") ||
  "https://alam-irauto.onrender.com/data";
const FALLBACK_MEDIA = "https://pub-377a591731b24d0f904285111f9cf04f.r2.dev";

/** Resolve a listing image key to a browser URL (R2 tenants/* or legacy /data). */
export function listingImageUrl(key: string | undefined): string | null {
  if (!key?.trim()) return null;
  if (key.startsWith("http://") || key.startsWith("https://")) return key;
  const path = key.replace(/^\/+/, "");
  if (path.startsWith("tenants/")) {
    const base = (
      import.meta.env.VITE_LUMORA_MEDIA_BASE ||
      LUMORA_PROD_MEDIA_BASE_URL ||
      FALLBACK_MEDIA
    ).replace(/\/+$/, "");
    return `${base}/${path}`;
  }
  return `${LEGACY_MEDIA}/${path}`;
}
